import React from 'react';
import Presenter from './Presenter';
import { IContainerProps } from './types';

const AuthLayoutContainer = (props: IContainerProps) => {
    return (
        <Presenter {...props} />
    );
};

export default AuthLayoutContainer;